export const SET_PROGRAMAS = 'SET_PROGRAMAS';
export const LOADING = 'LOADING';
export const ERROR = 'ERROR';
export const LOADING_LOGIN = 'LOADING_LOGIN';
export const ERROR_LOGIN = 'ERROR_LOGIN';
export const SET_USER = 'SET_USER';
export const LOGOUT = 'LOGOUT';
export const SWITCH_ADMIN_MENU = 'SWITCH_ADMIN_MENU';
export const SET_PROGRAMA_SELECTED = 'SET_PROGRAMA_SELECTED';
export const SET_PROGRAMA_UPDATED = 'SET_PROGRAMA_UPDATED';
export const LOADING_IMAGE = 'LOADING_IMAGE';
export const IMAGE_UPLOADED = 'IMAGE_UPLOADED';
export const SET_PROGRAMA_CREATED = 'SET_PROGRAMA_CREATED';
